export const GET_ALL_VISITS = 'GET_ALL_VISITS';
export const GET_VISITS_HOURS = 'GET_VISITS_HOURS';
export const SING_UP_VISIT = 'SING_UP_VISIT';
export const SING_OFF_VISIT = 'SING_OFF_VISIT';
export const USER_VISITS = 'USER_VISITS';
//export const SIGN_OUT = 'SIGN_OUT';


